module.exports = __webpack_public_path__ + "img/rank_major.a582ab76.svg";